export { isDereferenced } from './is-dereferenced'
